import { SET_PAYMENT_CURRENCIES } from "./action-types";

// action creator : function which returns an action
export const setPaymentCurrencies = (paymentCurrencies) => ({
  type: SET_PAYMENT_CURRENCIES,
  payload: { paymentCurrencies },
});
